<template>
  <el-row :gutter="20">
    <el-col :span="24">
      <div class="classify" v-if="firstClassifyList.length > 0">
        <h5 class="classify-title">分类</h5>
        <div class="classify-body">
          <span @click="trigger('firstClassifyList', index)" :class="item.active ? 'classify-item text-ellipsis classify-active' : 'classify-item text-ellipsis'" v-for="(item,index) in firstClassifyList" :key="item.id">{{ item.name }}</span>
        </div>
      </div>
    </el-col>
    <el-col :span="24">
      <div class="dividing-line" v-if="secondClassifyList.length > 0"></div>
    </el-col>
    <el-col :span="24">
      <div class="classify" v-if="secondClassifyList.length > 0">
        <h5 class="classify-title">科目</h5>
        <div class="classify-body">
          <div>
            <!--  :class="showMoreState ? '' : 'hidden-height'" -->
            <span @click="trigger('secondClassifyList', index)" :class="item.active ? 'classify-item text-ellipsis classify-active' : 'classify-item text-ellipsis'" v-for="(item,index) in secondClassifyList" :key="index">{{ item.name }}</span>
          </div>
          <!-- <div @click="showMore" class="show-more">{{ showMoreState ? '收起' : '查看更多' }}<i></i></div> -->
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props:{
    data:{
      type:Object,
      default:()=>{}
    }
  },
  data(){
    return{
      firstClassifyList:[],
      secondClassifyList:[],
      showMoreState:false
    }
  },
  watch:{
    data(val){
      console.log(val,455);
      // this.firstClassifyList = val.children
      this.handlePropData(val)
    },
  },
  methods:{
    handlePropData(obj){
      this.firstClassifyList = obj.children
      let allChildren = []
      if(this.firstClassifyList.length > 0){
        this.firstClassifyList.forEach(el=>{
        this.$set(el,'active',false)
        allChildren.push(...el.children)
      })
      if(this.firstClassifyList[0].name != '全部'){
         this.firstClassifyList.unshift({
          level: 1,
          name: "全部",
          active:true,
          children:allChildren
        })
      }else{
        this.firstClassifyList[0].active = true
      }
      this.secondClassifyList = this.firstClassifyList[0].children
      if(this.secondClassifyList.length > 0){
        this.secondClassifyList.forEach(el=>{
        this.$set(el,'active',false)
      })
      if(this.secondClassifyList[0].name != '全部'){
         this.secondClassifyList.unshift({
          level: 1,
          name: "全部",
          active:true,
          children:[]
        })
      }else{
        this.secondClassifyList[0].active = true
      }
      }
      }else{
        this.firstClassifyList = []
        this.secondClassifyList = []
      }
      
     
      
      
      console.log(this.firstClassifyList,this.secondClassifyList);
    },
    trigger(key, index){
      let secondId = []
      this[key].forEach( el => this.$set(el,'active',false) )
      this.$set(this[key][index],'active',true)
      this.$emit('saveIndex',key,index)
      if(key == 'firstClassifyList'){
        this.secondClassifyList = this[key][index].children
        
        this.secondClassifyList.forEach( el => {
          this.$set(el,'active',false)
          if(el.id) secondId.push(el.id)
        } )
        this.$emit('changeIds',secondId)
        if(this.secondClassifyList[0].name != '全部'){
         this.secondClassifyList.unshift({
          level: 1,
          name: "全部",
          active:true,
          children:[]
        })

      }else{
        this.secondClassifyList[0].active = true
      }
      }else{
        if(this[key][index].name == '全部'){
          this[key].forEach( el => el.id && secondId.push(el.id) )
        }else{
          secondId.push(this[key][index].id)
        }
        
        this.$emit('changeIds',secondId)
      }
    },
    showMore(){
      this.showMoreState = !this.showMoreState
    }
  }
};
</script>

<style lang="less" scoped>
.classify{
  display: flex;
  margin: 15px 0;
  .classify-title{
    flex-shrink: .1;
    margin: 5px 0;
    padding: 5px 10px 5px 5px;
    width: 50px;
    font-size: 14px;
    font-weight: bold;
  }
  .classify-body{
    position: relative;
    width: 100%;
    .hidden-height{
      height: 80px;
      overflow: hidden;
    }
    .classify-item{
      display: inline-block;
      margin: 5px 0;
      padding: 5px 10px;
      font-family: '微软雅黑';
      font-size: 14px;
      font-weight: 400;
      font-style: normal;
      color: #606266;
      cursor: pointer;
      &:hover{
        background-color: #f8f8f8;
        border-radius: 25px;
      }
    }

    .classify-active{
      color: #fc5e5e;
    }

    .show-more{
      position: absolute;
      bottom: -20px;
      left: 50%;
      transform: translate(-50%,0);
      font-family: '微软雅黑';
      font-weight: 400;
      font-style: normal;
      color: #909399;
      text-align: center;
      z-index: 100;
      cursor: pointer;
    }
  }
}
.dividing-line{
  border-bottom: 2px dashed #dcdfe6;
}
</style>



// WEBPACK FOOTER //
// src/components/CommodityClassificationManagement/components/classification.vue